var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerIconArrowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33101 7.69219L4.34195 2.59531C4.29508 2.53438 4.22164 2.5 4.14508 2.5H2.93726C2.83258 2.5 2.77476 2.62031 2.83883 2.70156L6.9857 8L2.83883 13.2984C2.8244 13.3169 2.81545 13.339 2.813 13.3622C2.81054 13.3855 2.81469 13.409 2.82496 13.43C2.83522 13.4511 2.8512 13.4688 2.87106 13.4811C2.89092 13.4935 2.91386 13.5001 2.93726 13.5H4.14508C4.22164 13.5 4.29508 13.4641 4.34195 13.4047L8.33101 8.30937C8.4732 8.12656 8.4732 7.87344 8.33101 7.69219ZM13.081 7.69219L9.09195 2.59531C9.04508 2.53438 8.97164 2.5 8.89508 2.5H7.68726C7.58258 2.5 7.52476 2.62031 7.58883 2.70156L11.7357 8L7.58883 13.2984C7.5744 13.3169 7.56545 13.339 7.563 13.3622C7.56054 13.3855 7.56469 13.409 7.57496 13.43C7.58522 13.4511 7.6012 13.4688 7.62106 13.4811C7.64092 13.4935 7.66387 13.5001 7.68726 13.5H8.89508C8.97164 13.5 9.04508 13.4641 9.09195 13.4047L13.081 8.30937C13.2232 8.12656 13.2232 7.87344 13.081 7.69219Z",
    fill: "#1F2027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerIconArrowClose);
export default __webpack_public_path__ + "static/media/drawer_icon_arrow_close.80376cd427a52b20bf939caf7096dab6.svg";
export { ForwardRef as ReactComponent };